import { createWebviewScreen } from 'shared/src/component';

/**
 * 상품 리뷰 목록 화면(`/goods/:goodsSno/reviews`, 내용은 웹뷰).
 *
 * 전용 화면으로 두는 이유는 Cart / OrderDetail 과 같다 — 범용 `WebViewScreen` 으로 열면
 * 목적지가 `url` params 문자열로 들어가 주소가 `/goods/123/reviews` 로 유지되지 않는다.
 *
 * 상세에서 리뷰 목록으로 가는 `useMoveToReviewList` 는 이미 이 경로를
 * `ably://webview?url=/goods/{sno}/reviews` 로 만들어 열고 있어, `WEBVIEW_WRAPPED_NATIVE_SCREENS`
 * 등록만으로 그 진입이 이 화면으로 온다. `beauty_recommend_option_sno` 같은 쿼리는 path
 * 세그먼트가 아니므로 그대로 웹뷰 URL 로 승계된다.
 *
 * ⚠️ `/goods/:goodsSno/reviews/photo` 는 네이티브 전용 경로다(`NATIVE_ONLY_WEBVIEW_PATTERNS`).
 * 세그먼트 수가 달라 이 라우트와 충돌하지 않는다.
 */
export const GoodsReviewListScreen = createWebviewScreen({
  screen: 'GoodsReviewList',
  title: '리뷰',
});
